import { render, staticRenderFns } from "./EditDocumentType.vue?vue&type=template&id=5f9ead78&"
import script from "./EditDocumentType.vue?vue&type=script&lang=js&"
export * from "./EditDocumentType.vue?vue&type=script&lang=js&"
import style0 from "./EditDocumentType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports